import { useState, useRef, useEffect } from "react";
import { Button, Input, Toast } from "antd-mobile";
import { useNavigate } from "react-router-dom";
import search_bg from "../assets/search_bg.png";
import { LeftOutlined } from "@ant-design/icons";
import { useSearchParams } from "react-router-dom";
import { sendCodeMsg, validateverificationcode } from "../tool/api";

const COUNT_DOWN_SECONDS = 60;

export default function QueryPage() {
  const navigate = useNavigate();
  const [phone, setPhone] = useState("");
  const [code, setCode] = useState("");
  const [isPhoneValid, setIsPhoneValid] = useState(false);

  const [countdown, setCountdown] = useState(0);
  const countdownRef = useRef<any>(null);

  const [searchParams, setSearchParams] = useSearchParams();

  // 获取特定参数的值
  const typeCode = searchParams.get("typeCode");

  const handleQuery = () => {
    const trimmedPhone = phone.trim();
    if (!trimmedPhone) {
      Toast.show({
        content: "请输入手机号码",
      });
      return;
    }
    const phoneRegex = /^1[3-9]\d{9}$/;
    if (!phoneRegex.test(trimmedPhone)) {
      Toast.show({
        content: "请输入正确的手机号码",
      });
      return;
    }
    validateverificationcode({
      applicantPhone: trimmedPhone,
      smsCode: code,
    }).then((resp) => {
      const { code, message ,data} = resp;
      if (+code === 1 && message) {
        Toast.show({
          content: message || "验证码错误",
        });
        return
      }else{
        navigate(`/list?phone=${trimmedPhone}&typeCode=${typeCode}&token=${data}`);
      }
    });

    
  };

  // 发送验证码
  const sendVerificationCode = () => {
    if (!isPhoneValid) {
      Toast.show({
        content: "请输入正确的手机号码",
      });
      return;
    }

    sendCodeMsg({
      applicantPhone: phone,
      typeCode,
    });
    // 模拟发送验证码请求
    console.log(`发送验证码到: ${phone}`);
    Toast.show({
      content: `验证码已发送至 ${phone}，请注意查收`,
    });
    // 开始倒计时
    setCountdown(60);
    countdownRef.current = setInterval(() => {
      setCountdown((prev) => {
        if (prev <= 1) {
          clearInterval(countdownRef.current);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
  };

  useEffect(() => {
    const regex = /^1[3-9]\d{9}$/;
    setIsPhoneValid(regex.test(phone));
  }, [phone]);

  return (
    <div
      style={{
        height: "100%",
        minHeight: "100vh",
        padding: "16px",
        backgroundColor: "white",
      }}
    >
      <div
        style={{
          height: 45,
          display: "flex",
          alignItems: "center",
          padding: "0 12px",
          marginBottom: "16px",
          fontWeight: 600,
          fontSize: "17px",
        }}
      >
        <LeftOutlined onClick={() => navigate(-1)} />
      </div>
      <div
        style={{
          padding: "16px",
          borderRadius: "8px",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: "12px",
          }}
        >
          <div>
            <div
              style={{
                marginBottom: "12px",
                fontSize: "17px",
                fontWeight: 600,
              }}
            >
              工单查询
            </div>
            <div>您的诉求，我们会积极反馈!</div>
          </div>
          <img style={{ width: 62, height: 62 }} src={search_bg} alt="" />
        </div>
        <Input
          placeholder="请输入您的手机号码查询"
          value={phone}
          onChange={(val) => setPhone(val)}
          clearable
          style={{
            backgroundColor: "#F6F7F7",
            borderRadius: 10,
            height: 40,
            fontSize: 12,
            padding: "0 10px",
          }}
        />
        <div className="yzm">
          <Input
            placeholder="请输入验证码"
            value={code}
            onChange={(val) => setCode(val)}
            clearable
            style={{
              backgroundColor: "#F6F7F7",
              borderRadius: 10,
              height: 40,
              fontSize: 12,
              padding: "0 10px",
            }}
          />
          <Button
            color="primary"
            onClick={sendVerificationCode}
            disabled={!isPhoneValid || countdown > 0 || !phone}
            className="send"
          >
            {countdown > 0 ? `重新发送(${countdown}s)` : "发送验证码"}
          </Button>
        </div>
        <Button
          color="primary"
          block
          style={{ marginTop: 24, borderRadius: 20 }}
          onClick={handleQuery}
          disabled={!isPhoneValid || !phone || !code || code.length != 6}
        >
          查询
        </Button>
      </div>
    </div>
  );
}
